import { PlusOutlined, UploadOutlined } from '@ant-design/icons'
import { Organization, OrganizationMember } from '@prisma/client'
import { Button, Dropdown, Flex, MenuProps, Modal } from 'antd'
import React, { useState } from 'react'
import { DesignSystem } from '~/core/designSystem'
import { useUpload } from '~/features/driveFile/client/hooks/useUpload'
import { FeatureFormConfigurationClient } from '~/features/formConfiguration/client'
import { InputUploadItem } from '~/features/formConfiguration/client/components/CustomInputs/InputUpload'
import { Icon } from '~/features/shared/icons'

type Props = {
  organization: Organization
  organizationMember: OrganizationMember
  onSuccess: () => void
}

export const UploadButton: React.FC<Props> = ({
  organization,
  organizationMember,
  onSuccess,
}) => {
  const [isOpen, setOpen] = useState(false)
  const [files, setFiles] = useState<InputUploadItem[]>([])

  const upload = useUpload({ organization, organizationMember })

  const onClick = () => {
    setOpen(true)
    setFiles([])
  }

  const handleChange = (items: InputUploadItem[]) => {
    if (upload.isLoading) {
      return
    }

    setFiles(items)
  }

  const handleCancel = () => {
    if (upload.isLoading) {
      return
    }

    setOpen(false)
    setFiles([])
  }

  const handleSubmit = async () => {
    await upload.uploadManyFiles(files)

    onSuccess()

    handleCancel()
  }

  const handleClickDocs = async () => {
    await upload.createOneFile()

    onSuccess()

    handleCancel()
  }

  const canSubmit = files.length > 0

  const items: MenuProps['items'] = [
    {
      key: 'upload',
      label: 'File upload',
      icon: <UploadOutlined />,
      onClick,
    },
    {
      key: 'docs',
      label: 'Docs',
      icon: (
        <Icon
          name="document-text"
          style={{ color: DesignSystem.ThemeConst.APPLE_BLUE }}
        />
      ),
      onClick: handleClickDocs,
    },
  ]

  return (
    <>
      <Dropdown menu={{ items }} trigger={['click']}>
        <Button icon={<PlusOutlined />} size="small" loading={upload.isLoading}>
          New
        </Button>
      </Dropdown>

      <Modal open={isOpen} footer={false} onCancel={handleCancel}>
        {isOpen && (
          <Flex justify="center" vertical>
            <FeatureFormConfigurationClient.InputUpload
              isRequestSkipped={true}
              overflow="scrollY"
              onChange={handleChange}
              maxCount={5}
              disabled={upload.isLoading}
            />

            {canSubmit && (
              <Flex justify="center" className="mt-2">
                <Button
                  type="primary"
                  onClick={handleSubmit}
                  loading={upload.isLoading}
                >
                  Submit
                </Button>
              </Flex>
            )}
          </Flex>
        )}
      </Modal>
    </>
  )
}
